<template>
    <div v-if="reDry">
        <b-card class="m-0" no-body>
            <b-card-header class="d-flex justify-content-between align-items-center">
                <h5 v-if="isPenerimaan" class="modal-title">Penerimaan Re Dry</h5>
                <h5 v-else class="modal-title">{{ reDry.id ? 'Informasi' : 'Konfirmasi' }} Re Dry</h5>
            </b-card-header>
            <b-card-body>
                <div class="table-responsive">
                    <table class="table table-borderless">
                        <tr>
                            <th class="fit-column">Gudang Asal</th>
                            <td class="fit-column">:</td>
                            <th class="text-primary">{{ reDry.gudang.name }}</th>
                        </tr>
                        <tr>
                            <th class="fit-column">Tanggal Berangkat</th>
                            <td class="fit-column">:</td>
                            <th class="text-primary">{{ formatDate(reDry.tanggal_berangkat) }}</th>
                        </tr>
                        <tr v-if="!isKonfirmasi">
                            <th class="fit-column">Biaya</th>
                            <td class="fit-column">:</td>
                            <td v-if="isPenerimaan" class="text-primary">
                                <input v-validate="'required|min_value:0'" min="0" v-model="form.biaya" type="number" name="biaya" class="form-control">
                                <span class="text-danger">{{ errors.first('biaya') }}</span>
                            </td>
                            <th v-else class="text-primary">{{ reDry.penerimaan ? formatNumber(form.biaya) : '-' }}</th>
                        </tr>
                        <tr v-if="!isKonfirmasi">
                            <th class="fit-column">Metode Pembayaran</th>
                            <td class="fit-column">:</td>
                            <td v-if="isPenerimaan">
                                <div class="input-group single mb-0 d-flex">
                                    <multiselect class='w-auto flex-grow-1' v-validate="'required'" name="metode_pembayaran" v-model="form.metode_pembayaran" :options="metodeOptions" :placeholder="'Pilih'" :searchable="true"
                                        label="value" track-by="name" :allowEmpty="false" :show-labels="false"></multiselect>
                                </div>
                                <span class="text-danger">{{ errors.first('metode_pembayaran') }}</span>
                            </td>
                            <th v-else class="text-primary">{{ reDry.penerimaan ? form.metode_pembayaran.value : '-' }}</th>
                        </tr>
                        <tr>
                            <th class="fit-column">Berat Berangkat (kg)</th>
                            <td class="fit-column">:</td>
                            <th class="text-primary">{{ formatNumber(totalBobotBerangkat) }}</th>
                        </tr>
                        <tr v-if="!isKonfirmasi">
                            <th class="fit-column">Berat Tiba (kg)</th>
                            <td class="fit-column">:</td>
                            <th class="text-primary">{{ formatNumber(reDry.bobot_tiba) }}</th>
                        </tr>
                    </table>
                </div>

                <template>
                    <label class="form-control-label mt-3 pl-1">
                        Detail Barang
                    </label>
                    <div class="alert alert-primary mb-1" role="alert">
                        Total Inputan : <strong class="text-nowrap">{{ isKonfirmasi ? formatNumber(barangs.length) : formatNumber(reDry.kemasans.length) }}</strong>
                    </div>
                    <div class="table-responsive">
                        <table class="table">
                            <tr>
                                <th>No.</th>
                                <th>Kode</th>
                                <th>Berat</th>
                                <th>Grade</th>
                                <th v-if="!isKonfirmasi"></th>
                            </tr>
                            <template v-if="isKonfirmasi">
                                <tr v-for="(item, index) in barangs">
                                    <th class="text-primary pl-0">
                                        {{ index+1 }}
                                    </th>
                                    <th class="text-primary pl-0">
                                        {{ formatValue(item.code) }}
                                    </th>
                                    <th class="text-primary">
                                        {{ item.latest_bobot ? formatNumber(item.latest_bobot) + ' KG' : '-' }}
                                    </th>
                                    <th class="text-primary pr-0">
                                        {{ item.latest_grade ? item.latest_grade.name : '-' }}
                                    </th>
                                </tr>
                            </template>
                            <template v-else>
                                <tr v-for="(item, index) in reDry.kemasans">
                                    <th class="text-primary pl-0">
                                        {{ index+1 }}
                                    </th>
                                    <th class="text-primary pl-0">
                                        {{ formatValue(item.pembelian_tembakau.code) }}
                                    </th>
                                    <th class="text-primary">
                                        {{ item.bobot ? formatNumber(item.bobot) + ' KG' : '-' }}
                                    </th>
                                    <th class="text-primary pr-0">
                                        {{ item.grade ? item.grade.name : '-' }}
                                    </th>
                                    <th class="fit-column text-center">
                                        <button :disabled="isLoading" type="button" title="Print QrCode" @click="printQrCode(item.pembelian_tembakau)" class="btn btn-link px-1"><i class="fas fa-print"></i></button>
                                    </th>
                                </tr>
                            </template>
                        </table>
                    </div>
                </template>

                <template v-if="isPenerimaan || reDry.penerimaan">
                    <label class="form-control-label mt-3 pl-1">
                        Barang Kembali
                    </label>
                    <div class="alert alert-primary mb-1" role="alert">
                        Total Inputan : <strong class="text-nowrap">{{ formatNumber(barangs.length) }}</strong>
                    </div>
                    <div class="table-responsive">
                        <table class="table">
                            <tr>
                                <th>No.</th>
                                <th v-if="reDry.penerimaan">Kode</th>
                                <th>Berat</th>
                                <th>Grade</th>
                                <th v-if="isPenerimaan" class="text-center">Aksi</th>
                                <th v-else></th>
                            </tr>
                            <tr v-for="(item, index) in barangs">
                                <th class="text-primary pl-0">
                                    {{ index+1 }}
                                </th>
                                <th v-if="reDry.penerimaan" class="text-primary pl-0">
                                    {{ formatValue(item.code) }}
                                </th>
                                <td v-if="isPenerimaan" class="text-primary fit-column">
                                    <input style="width: 10rem;" v-validate="'required|min_value:0'" min="0" v-model="barangs[index].bobot_tiba" type="number" :name="'bobot_tiba'+index" class="form-control">
                                    <span class="text-danger">{{ errors.first('bobot_tiba'+index) }}</span>
                                </td>
                                <th v-else class="text-primary">
                                    {{ item.bobot_tiba ? formatNumber(item.bobot_tiba) + ' KG' : '-' }}
                                </th>
                                <td v-if="isPenerimaan" class="text-nowrap pl-0 fit-column">
                                    <div class="input-group mb-0 d-flex" style="width: 20rem;">
                                        <multiselect style="width:15rem; max-width: 15rem;" :class="'w-auto flex-grow-1'" v-validate="'required'" v-model="barangs[index].grade_tiba" :options="gradeOptions" placeholder="" :searchable="true"
                                            label="name" track-by="id" :allowEmpty="false" :name="'grade_tiba'+index" :show-labels="false"></multiselect>
                                        <div class="input-group-append">
                                            <button class="btn btn-primary" type="button" @click="findGrade(index)"><i class="fas fa-search"></i> Pilih</button>
                                        </div>
                                    </div>
                                    <span class="text-danger">{{ errors.first('grade_tiba'+index) }}</span>
                                </td>
                                <th v-else class="text-primary pr-0">
                                    {{ item.grade_tiba ? item.grade_tiba.name : '-' }}
                                </th>
                                <td v-if="isPenerimaan" class="text-center">
                                    <button v-if="barangs.length > 1" type="button" title="Delete" @click="deleteBarang(index)" class="btn btn-link text-danger px-1"><i class="fas fa-times-circle"></i></button>
                                </td>
                                <th v-else class="fit-column text-center">
                                    <button :disabled="isLoading" type="button" title="Print QrCode" @click="printQrCode(item)" class="btn btn-link px-1"><i class="fas fa-print"></i></button>
                                </th>
                            </tr>
                            <tr v-if="isPenerimaan">
                                <td class="pl-0" colspan="4">
                                    <button class="btn btn-sm btn-primary" type="button" @click="addBarang"><i class="fas fa-plus"></i> Barang</button>
                                </td>
                            </tr>
                        </table>
                    </div>
                </template>
            </b-card-body>
            <b-card-footer class="d-flex flex-row-reverse">
                <button :disabled="isLoading" v-if="isKonfirmasi" @click="isLoading = true; $emit('koreksi')" type="button" class="btn btn-secondary">Koreksi</button>
                <button :disabled="isLoading" v-if="isKonfirmasi" @click="isLoading = true; $emit('ok')" type="button" class="btn btn-primary mr-2">OK</button>
                <button :disabled="isLoading" v-if="!isKonfirmasi" @click="isLoading = true; $emit('cancel')" type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button :disabled="isLoading" v-if="!isKonfirmasi && !isPenerimaan" @click="print" type="button" class="btn btn-primary mr-2"><i class="fas fa-print"></i> Print</button>
                <button :disabled="isLoading" v-if="isPenerimaan" @click="save" type="button" class="btn btn-primary mr-2">Simpan</button>
            </b-card-footer>
        </b-card>

        <b-modal v-model="selectGrade" size="lg" :hide-header="true" :hide-footer="true">
            <grade-selector @selected="gradeSelected" @cancel="selectGrade = false"></grade-selector>
        </b-modal>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import GradeSelector from '../grades/Selector';

export default {
    name: "re-dry-viewer",

    props: {
        isKonfirmasi: {
            type: Boolean,
            default: false,
        },

        isPenerimaan: {
            type: Boolean,
            default: false,
        },

        value: {
            type: Object,
            default: () => {},
        },

        barangs: {
            type: Array,
            default: () => [],
        },
    },

    components: {
        Multiselect,
        GradeSelector,
    },

    data() {
        return {
            reDry: null,
            kemasanIndex: 0,
            selectGrade: false,
            gradeOptions: [],
            form: {},
            metodeOptions: [
                {
                    name: 'tunai',
                    value: 'Tunai',
                },
                {
                    name: 'transfer',
                    value: 'Transfer',
                },
            ],
        }
    },

    created() {
    },

    mounted() {
        if (this.value) {
            this.initReDry();
        }
    },

    computed: {
        totalBobotBerangkat() {
            let total = 0;
            this.reDry.kemasans.forEach(kemasan => {
                total += this.isKonfirmasi ? kemasan.latest_bobot : kemasan.bobot;
            });

            return total;
        },
    },

    watch: {
        value() {
            this.initReDry();
        }
    },

    methods: {
        initReDry() {
            let self = this;

            self.reDry = Object.assign({}, self.value);

            if (self.isKonfirmasi) {
                self.reDry.kemasans = self.value.barangs;
            }

            if (self.isPenerimaan && !self.reDry.penerimaan) {
                self.reDry.kemasans.forEach((kemasan, index) => {
                    self.barangs[index] = Object.assign({}, {
                        bobot_tiba: '',
                        grade_tiba: null,
                    });
                });
            }

            if (self.reDry.penerimaan) {
                self.reDry.pembelian_tembakaus.forEach((pembelian, index) => {
                    self.barangs[index] = Object.assign({}, {
                        id: pembelian.id,
                        code: pembelian.code,
                        bobot_tiba: pembelian.bobot,
                        grade_tiba: Object.assign({}, pembelian.grade),
                    });
                });
                let metodePembayaranIndex = self.metodeOptions.findIndex(option => option.name == self.reDry.penerimaan.metode_pembayaran);
                self.form.biaya = self.reDry.penerimaan.biaya;
                self.form.metode_pembayaran = Object.assign({}, self.metodeOptions[metodePembayaranIndex]);
            }
        },

        addBarang() {
            this.barangs.push(Object.assign({}, {
                bobot_tiba: null,
                grade_tiba: null,
            }));
        },

        deleteBarang(index) {
            this.barangs.splice(index, 1);
        },

        findGrade(index) {
            this.kemasanIndex = index;
            this.selectGrade = true;
        },

        gradeSelected(grade) {
            let self = this;

            let index = self.gradeOptions.findIndex(b => b.id == grade.id);
            if (index > -1) {
                self.barangs[self.kemasanIndex].grade_tiba = Object.assign({}, self.gradeOptions[index]);
            } else {
                self.barangs[self.kemasanIndex].grade_tiba = Object.assign({}, grade);
                self.gradeOptions.push(grade);
            }
            self.selectGrade = false;
        },

        print() {
            let self = this;

            self.isLoading = true;
            self.$Progress.start();
            var newIframe = document.createElement('iframe');
            newIframe.width = '0';
            newIframe.height = '0';
            newIframe.src = '/re-dries/print/'+self.reDry.id;
            document.body.appendChild(newIframe);
            newIframe.focus();
            newIframe.onload = function () {
                self.isLoading = false;
                self.$Progress.finish();
                newIframe.contentWindow.print();
                self.$emit('cancel');
            }
        },

        save() {
            let self = this;

            self.$validator.validateAll().then(result => {
                if (result) {
                    this._save();
                }
            });
        },

        _save() {
            let self = this,
                data = null;

            self.isLoading = true;
            if (self.isPenerimaan) {
                data = Object.assign({}, {
                    biaya: self.form.biaya,
                    metode_pembayaran: self.form.metode_pembayaran.name,
                    kemasan_ids: [],
                    bobot_tibas: [],
                    grade_tiba_ids: [],
                });
                self.barangs.forEach(kemasan => {
                    data.kemasan_ids.push(kemasan.id);
                    data.bobot_tibas.push(kemasan.bobot_tiba);
                    data.grade_tiba_ids.push(kemasan.grade_tiba.id);
                });
            }

            let api = '/api/re-dries/'+self.reDry.id+'/penerimaan';

            self.$Progress.start();
            axios({
                method: 'post',
                url: api,
                data: data
            })
            .then(function (response) {
                Toast.fire({
                    icon: 'success',
                    title: response.data.message
                });
                self.isLoading = false;
                self.$Progress.finish();
                self.$emit('saved', response.data.data);
            })
            .catch(function (error) {
                self.requestFailed(error);
            });
        },

        printQrCode(data) {
            let self = this;
            self.isLoading = true;
            self.$Progress.start();
            var newIframe = document.createElement('iframe');
            newIframe.width = '0';
            newIframe.height = '0';
            newIframe.src = '/pembelian-tembakaus/print/' + data.id;
            document.body.appendChild(newIframe);
            newIframe.focus();
            newIframe.onload = function () {
                self.isLoading = false;
                self.$Progress.finish();
                newIframe.contentWindow.print();
            }
        },
    },
}
</script>
<style>
.fit-column {
    width: 0.1%;
    white-space: nowrap;
}

th, td {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
}
</style>
